import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, KeepAlive as _KeepAlive, resolveComponent as _resolveComponent, resolveDirective as _resolveDirective, withCtx as _withCtx, withDirectives as _withDirectives } from "vue";
import { computed, reactive } from "vue";
import { useKeepAlive } from "@/store";
const __default__ = {
  name: 'App'
};
export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {
    const keepAlive = useKeepAlive();
    const excludeKeepAlive = computed(() => {
      return keepAlive.getExclude;
    });
    // 需要缓存的路由
    const keepAliveIncludeList = reactive(['index', 'extracurricular-content', 'growth-record']);
    return (_ctx, _cache) => {
      const _component_router_view = _resolveComponent("router-view");
      const _directive_wechat_title = _resolveDirective("wechat-title");
      return _withDirectives((_openBlock(), _createBlock(_component_router_view, null, {
        default: _withCtx(({
          Component
        }) => [(_openBlock(), _createBlock(_KeepAlive, {
          include: keepAliveIncludeList,
          exclude: _unref(excludeKeepAlive)
        }, [(_openBlock(), _createBlock(_resolveDynamicComponent(Component)))], 1032, ["include", "exclude"]))]),
        _: 1
      })), [[_directive_wechat_title, _ctx.$route.meta.title]]);
    };
  }
});